// extracted by mini-css-extract-plugin
export default {"container":"ScenarioSymbol_container__BcW5a","symbol-container":"ScenarioSymbol_symbol-container__kJqe0"};